import * as React from 'react';
import * as styles from './Builders.css';

interface IBuildersProps {
  list: React.ReactNode;
  toggle: React.ReactNode;
}

export function Builders({ list, toggle }: IBuildersProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['list']}>{list}</div>
      <div className={styles['toggle']}>{toggle}</div>
    </div>
  );
}
